/**
 * Splash Screen Management Type Definitions
 * Based on docs/SPLASH_SCREEN_API_DOCUMENTATION.md
 */

export interface SplashScreen {
  splashId: string;
  title: string;
  description: string | null;
  imageUrl: string | null;
  primaryCtaText: string | null;
  primaryCtaAction: string | null;
  secondaryCtaText: string | null;
  secondaryCtaAction: string | null;
  isSkippable: boolean;
  sequenceOrder: number;
  durationSeconds: number | null;
  contentReferenceId: string | null;
  isActive: boolean;
  startDate: string | null;
  endDate: string | null;
  targetPlatform: string;
  language: string;
  createdAt: string;
  updatedAt: string;
}

export interface SplashScreenCreateRequest {
  title: string;
  description?: string | null;
  imageUrl?: string | null;
  primaryCtaText?: string | null;
  primaryCtaAction?: string | null;
  secondaryCtaText?: string | null;
  secondaryCtaAction?: string | null;
  isSkippable?: boolean;
  sequenceOrder?: number;
  durationSeconds?: number | null;
  contentReferenceId?: string | null;
  isActive?: boolean;
  startDate?: string | null;
  endDate?: string | null;
  targetPlatform?: string;
  language?: string;
}

export interface SplashScreenUpdateRequest {
  title?: string;
  description?: string | null;
  imageUrl?: string | null;
  primaryCtaText?: string | null;
  primaryCtaAction?: string | null;
  secondaryCtaText?: string | null;
  secondaryCtaAction?: string | null;
  isSkippable?: boolean;
  sequenceOrder?: number;
  durationSeconds?: number | null;
  contentReferenceId?: string | null;
  isActive?: boolean;
  startDate?: string | null;
  endDate?: string | null;
  targetPlatform?: string;
  language?: string;
}

export interface SplashScreenQueryParams {
  page?: number;
  size?: number;
  isActive?: boolean;
  effectiveFrom?: string;
  effectiveTo?: string;
  targetPlatform?: string;
  language?: string;
}

export interface SplashScreensData {
  items: SplashScreen[];
  page: number;
  size: number;
  totalItems: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export const TARGET_PLATFORM_OPTIONS: { value: string; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'android', label: 'Android' },
  { value: 'ios', label: 'iOS' },
];

export const LANGUAGE_OPTIONS: { value: string; label: string }[] = [
  { value: 'en', label: 'English' },
  { value: 'my', label: 'Myanmar' },
];

export const formatTargetPlatform = (platform: string): string => {
  const option = TARGET_PLATFORM_OPTIONS.find((o) => o.value === platform);
  return option?.label ?? platform;
};
